import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Box } from "@zillow/constellation-10";
import { v8ResponsiveToPanda, resolveSpacing, migrateColorToken } from "@zillow/zrs-cms";
import { pickAnimationDomProps } from "../../components/BlockAnimation/animationConfig.esm.js";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const BlockGridContent = ({
  attrs,
  index,
  innerBlocks
}) => {
  const {
    id,
    backgroundColor = null,
    padding = "none",
    gridColumnEnd: gridColumnEndAttr,
    justifySelf,
    alignSelf,
    alignItems,
    justifyContent,
    order,
    // Discard WordPress system keys that must not reach the DOM
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    anchor: _anchor,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    lock: _lock,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    metadata: _metadata,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    className: _className
  } = attrs ?? {};
  const gridColumnEnd = v8ResponsiveToPanda({
    default: "span 1",
    sm_lte: "span 12",
    ...gridColumnEndAttr
  });
  const resolveAlignment = (value) => {
    if (!value) return void 0;
    if (typeof value === "string") {
      return value === "None" || value === "none" ? "auto" : value;
    }
    const resolved = v8ResponsiveToPanda(value);
    const mapped = Object.fromEntries(Object.entries(resolved).map(([k, v]) => [k, v === "none" || v === "None" ? "auto" : v]));
    return Object.keys(mapped).length > 0 ? mapped : void 0;
  };
  const resolveOrder = (value) => {
    if (!value) return void 0;
    if (typeof value === "string") return value;
    const resolved = v8ResponsiveToPanda(value);
    return Object.fromEntries(Object.entries(resolved).map(([k, v]) => [k, v === "none" ? "0" : v]));
  };
  const className = css({
    display: "flex",
    flexDirection: "column",
    backgroundColor: backgroundColor ? migrateColorToken(backgroundColor) ?? void 0 : void 0,
    padding: resolveSpacing(padding),
    gridColumnEnd,
    justifySelf: resolveAlignment(justifySelf),
    alignSelf: resolveAlignment(alignSelf),
    alignItems: resolveAlignment(alignItems),
    justifyContent: resolveAlignment(justifyContent),
    order: resolveOrder(order)
  });
  return /* @__PURE__ */ jsx(Box, { id, className, ...pickAnimationDomProps(attrs), children: generateBlockList({
    blocks: innerBlocks
  }) }, index);
};
export {
  BlockGridContent as default
};
